<div class="accordion" id="accordionExample-{{ position }}">
  <div class="accordion-item" *ngIf="csDetails.technologies">
    <h2 class="accordion-header" id="headingTwo-{{ position }}">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        attr.data-bs-target="#collapseTwo-{{ position }}"
        aria-expanded="true"
        attr.aria-controls="collapseTwo-{{ position }}"
        style="font-size: 13px"
      >
        Technology stack/preferences
      </button>
    </h2>
    <div
      id="collapseTwo-{{ position }}"
      class="accordion-collapse collapse"
      attr.aria-labelledby="headingTwo-{{ position }}"
      attr.data-bs-parent="#accordionExample-{{ position }}"
    >
      <div class="accordion-body px-3">
        <p class="desc-style">{{ csDetails?.technologies }}</p>
      </div>
    </div>
  </div>
  <div class="accordion-item" *ngIf="csDetails.submission_date">
    <h2 class="accordion-header" id="headingThree-{{ position }}">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        attr.data-bs-target="#collapseThree-{{ position }}"
        aria-expanded="true"
        attr.aria-controls="collapseThree-{{ position }}"
        style="font-size: 13px"
      >
        Last date of submission
      </button>
    </h2>
    <div
      id="collapseThree-{{ position }}"
      class="accordion-collapse collapse"
      attr.aria-labelledby="headingThree-{{ position }}"
      attr.data-bs-parent="#accordionExample-{{ position }}"
    >
      <div class="accordion-body px-3">
        <p class="desc-style">
          {{ csDetails?.submission_date | appFormat : "date" }}
        </p>
      </div>
    </div>
  </div>
  <div class="accordion-item" *ngIf="csDetails.poc_expectations">
    <h2 class="accordion-header" id="headingFour-{{ position }}">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        attr.data-bs-target="#collapseFour-{{ position }}"
        aria-expanded="true"
        attr.aria-controls="collapseFour-{{ position }}"
        style="font-size: 13px"
      >
        POC expectations
      </button>
    </h2>
    <div
      id="collapseFour-{{ position }}"
      class="accordion-collapse collapse"
      attr.aria-labelledby="headingFour-{{ position }}"
      attr.data-bs-parent="#accordionExample-{{ position }}"
    >
      <div class="accordion-body px-3">
        <p class="desc-style">{{ csDetails?.poc_expectations }}</p>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive-{{ position }}">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        attr.data-bs-target="#collapseFive-{{ position }}"
        aria-expanded="true"
        attr.aria-controls="collapseFive-{{ position }}"
        style="font-size: 13px"
      >
        Attachments ({{
          csDetails?.problem_statement_files.length | appFormat : "number"
        }})
      </button>
    </h2>
    <div
      id="collapseFive-{{ position }}"
      class="accordion-collapse collapse"
      attr.aria-labelledby="headingFive-{{ position }}"
      attr.data-bs-parent="#accordionExample-{{ position }}"
    >
      <div class="accordion-body">
        <div style="overflow-x: scroll">
          <div
            class="d-flex flex-row flex-nowrap overflow-auto"
            *ngIf="csDetails?.problem_statement_files.length > 0"
            style="padding: 10px 0"
          >
            <div
              class="card card-block mx-2"
              style="
                width: 150px;
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 15px;
                padding: 0 4px;
              "
              *ngFor="
                let x of csDetails?.problem_statement_files;
                let i = index
              "
              (click)="downloadFile(x)"
            >
              <mat-icon style="position: absolute; top: 0; right: 4px"
                >cloud_download</mat-icon
              >
              <mat-icon
                mat-list-icon
                class="material-icons my-auto fs-1 text-danger"
                style="width: 30px"
              >
                description</mat-icon
              >
              <p class="m-0" style="font-size: 10px; text-align: center">
                {{ x?.file_name }}
              </p>
            </div>
          </div>
          <div
            class="desc-style"
            *ngIf="csDetails?.problem_statement_files.length == 0"
            class="d-flex w-100 justify-content-center"
          >
            {{ commonText.no_files_attached }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSeven">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        attr.data-bs-target="#collapseSeven-{{ position }}"
        aria-expanded="true"
        attr.aria-controls="collapseSeven-{{ position }}"
        style="font-size: 13px"
      >
        Delivery Partner ({{ csDetails?.vendor.length | appFormat : "number" }})
      </button>
    </h2>
    <div
      id="collapseSeven-{{ position }}"
      class="accordion-collapse collapse"
      attr.aria-labelledby="headingSeven-{{ position }}"
      attr.data-bs-parent="#accordionExample-{{ position }}"
    >
      <div class="accordion-body">
        <div class="flex-container-1">
          <div class="flex-item p-1" *ngFor="let provider of csDetails?.vendor">
            <div class="trn-x" [ngStyle]="{ background: provider.color }">
              <div class="d-flex">
                <div>
                  <img
                    *ngIf="provider?.url"
                    src="{{ provider?.url }}"
                    style="width: 40px; height: 40px; border-radius: 50%"
                  />
                  <span
                    class="name-1"
                    *ngIf="!provider.url"
                    [ngStyle]="{ backgroundColor: provider?.logoColor }"
                    >{{ getName(provider?.name) }}</span
                  >
                </div>
                <h6
                  class="mb-0 mt-3 ml-2 trn-nm"
                  style="width: 80%"
                  matTooltip="{{ provider.name }}"
                >
                  {{ provider.name }}
                </h6>
              </div>
              <br />
              <div
                class="d-flex justify-content-start"
                matTooltip="Sector"
                style="font-size: 12px"
              >
                <mat-icon> business</mat-icon>
                <span class="ml-1 mt-1 fw-500">{{ provider.sector }}</span>
              </div>
              <div
                class="row"
                style="position: absolute; bottom: 8px; font-size: 12px"
              >
                <div
                  class="col-sm-8 d-flex justify-content-start"
                  style="font-size: 8px"
                >
                  <a
                    *ngIf="provider.link"
                    href="{{ provider.link }}"
                    target="_blank"
                    ><mat-icon style="color: #fff; font-size: 20px"
                      >link</mat-icon
                    ></a
                  >
                  <a *ngIf="provider.email" href="mailto:{{ provider?.email }}"
                    ><mat-icon style="color: #fff; font-size: 20px"
                      >mail</mat-icon
                    ></a
                  >
                </div>
                <div class="col-sm-4 d-flex justify-content-end float-right">
                  <mat-icon *ngIf="provider.is_recomended"
                    >thumb_up_alt</mat-icon
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
